import { Construction } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { t, type TranslationKey } from '@/locales/i18n';

interface ModulePlaceholderProps {
  titleKey: TranslationKey;
}

export function ModulePlaceholder({ titleKey }: ModulePlaceholderProps): JSX.Element {
  return (
    <div className="space-y-6 p-6">
      <h1 className="text-xl font-semibold">{t(titleKey)}</h1>
      <Card>
        <CardContent className="flex flex-col items-center gap-3 py-16 text-center">
          <Construction className="h-10 w-10 text-muted-foreground" />
          <div className="text-base font-medium">{t('modules.construction')}</div>
          <p className="max-w-md text-sm text-muted-foreground">{t('modules.constructionDesc')}</p>
        </CardContent>
      </Card>
    </div>
  );
}
